import { render } from "./TrainingGroupAddEditView.vue?vue&type=template&id=02fdf850"
import script from "./TrainingGroupAddEditView.vue?vue&type=script&lang=js"
export * from "./TrainingGroupAddEditView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__